export default function (data: any): string {
  return JSON.stringify(data)
}
